













































































import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
@Component
export default class JobDetail extends mixins(DictMixin) {
  @PropSync('detail') syncDetail!: any;
  @Prop() name!: any;
  @Prop() edit!: any;
  status = 2;
}
